import { render, staticRenderFns } from "./auditComicTable.vue?vue&type=template&id=3f49c8a4"
import script from "./auditComicTable.vue?vue&type=script&lang=js"
export * from "./auditComicTable.vue?vue&type=script&lang=js"
import style0 from "./auditComicTable.vue?vue&type=style&index=0&id=3f49c8a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports